import { useState, useEffect, useContext } from "react";
import { Card, Button, Table, Form, Input, InputNumber, Tabs, message, Modal } from "antd";
import { ReloadOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import listApi from "../../services/api";
import { AuthContext } from "../../context/AuthContext";

const { TabPane } = Tabs;

const ShipManagement = () => {
  const { userData } = useContext(AuthContext);
  const [form] = Form.useForm();
  const [selectedShip, setSelectedShip] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [listShip, setListShip] = useState([])
  const [loading, setLoading]= useState(false)

  useEffect(() => {
    fetchShips();
    if (selectedShip) {
      form.setFieldsValue({
        name: selectedShip.name,
        cost: selectedShip.cost,
      });
      setIsEditing(true);
    } else {
      form.resetFields();
      setIsEditing(false);
    }
  }, [selectedShip, form]);

  const fetchShips = async () => {
    setLoading(true)
    try {
      const response = await fetch(listApi.listShipCost, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          session_id: userData.session_id
        })
      });
      const data = await response.json();
      if (data.code === 200) {
        setLoading(false)
        console.log("check data",data)
        setListShip(data.list_shipcost.map(ship => ({
          id: ship.ID,
          name: ship.name,
          cost: ship.cost
        })));
      }
    } catch (error) {
      setLoading(false)
      console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (!values.name || !values.cost) {
        alert("Vui lòng điền đầy đủ thông tin trước khi lưu mã ship!");
        return;
      }
  
      const payload = {
        session_id: userData.session_id,
        ship_code: values.name, 
        money: values.cost
      };
  
      let url = listApi.createShipCost;
  
      // Nếu đang sửa (selectedShip tồn tại), cập nhật thay vì tạo mới
      if (selectedShip && selectedShip.id) { 
        payload.ship_cost_id = selectedShip.id;
        url = listApi.editShipCost;
      }
  
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      const result = await response.json();
      console.log("Kết quả:", result);
  
      if (result.code === 200) {
        alert(selectedShip ? "Mã ship đã được cập nhật!" : "Mã ship đã được tạo!");
        fetchShips();
        setSelectedShip(null);
        form.resetFields();
      } else {
        alert(`Lỗi: ${result.desc || "Không thể xử lý mã ship"}`);
      }
    } catch (error) {
      console.error("Lỗi khi xử lý mã ship:", error);
    }
  };
  


  const handleDeleteShip = (shipId) => {
    Modal.confirm({
      title: "Xác nhận xóa",
      content: "Bạn có chắc chắn muốn xóa gói ship này không?",
      okText: "Xóa",
      okType: "danger",
      cancelText: "Hủy",
      onOk: async () => {
        try {
          const response = await fetch(listApi.delShipCost, {
            method: "POST", 
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ 
              ship_cost_id: shipId, 
              session_id: userData.session_id 
            }),
          });
  
          const result = await response.json();
          if (result.code === 200) {
            message.success("Xóa mã ship thành công!");
            fetchShips(); // Load lại danh sách ship sau khi xóa
          } else {
            message.error(result.desc || "Xóa mã ship thất bại!");
          }
        } catch (error) {
          console.error("Lỗi khi xóa mã ship:", error);
          message.error("Đã xảy ra lỗi khi xóa mã ship.");
        }
      },
    });
  };

  const columns = [
    { title: "Tên gói", dataIndex: "name", key: "name" },
    { title: "Giá", dataIndex: "cost", key: "cost",      render: (price) => `${price.toLocaleString()} VND`, },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <>
          <Button icon={<EditOutlined />} onClick={() => setSelectedShip(record)} style={{ marginRight: 8 }}>
            Sửa
          </Button>
          <Button danger icon={<DeleteOutlined />} onClick={() => handleDeleteShip(record.id)}>
            Xóa
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        title="📊 THỐNG KÊ CÁC MÃ SHIP"
        extra={
          <>
            <Button icon={<ReloadOutlined />} onClick={fetchShips} loading={loading} style={{ marginRight: "10px" }}>Tải Lại</Button>
            <Button onClick={() => setSelectedShip(null)} type="primary" icon={<PlusOutlined />}>Tạo Mã Ship Mới</Button>
          </>
        }
        style={{ marginBottom: "20px" }}
      >
        <Table columns={columns} dataSource={listShip} pagination={{ pageSize: 10 }} loading={loading} />
      </Card>

      <Card
        title={isEditing ? `Sửa Mã Ship: ${selectedShip?.name}` : "Tạo Mã Ship Mới"}
      >
        <Tabs defaultActiveKey="1">
          <TabPane tab="Thông tin mã ship" key="1">
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Form.Item label="Tên gói:" name="name" rules={[{ required: true, message: "Vui lòng nhập tên gói!" }]}>
                <Input />
              </Form.Item>
              <Form.Item label="Giá:" name="cost" rules={[{ required: true, message: "Vui lòng nhập giá!" }]}>
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
              <Button type="primary" htmlType="submit" icon={<EditOutlined />}>{isEditing ? "Cập Nhật" : "Thêm Mã Ship"}</Button>
            </Form>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default ShipManagement;
